<script>
    import { CornerItem } from '@/components'

    export let data = {
        title: '',
        description: '',
        background: 'none',
        boxShadow: 'none',
        corner: 'left-top'
    }
</script>

<CornerItem class="corner-item" corner={data.corner} style={`background: ${data.background}; box-shadow: ${data.boxShadow};`}>
    <div class="title">{@html data.title}</div>
    <div class="description">{@html data.description}</div>
</CornerItem>

<style lang="scss" module>
    .title {
        color: #ffffff;
        font-size: 28px;
        font-weight: 700;
        line-height: 35px;
        text-align: center;
        margin-bottom: 22px;
    }

    .description {
        color: #ffffff;
        font-size: 18px;
        line-height: 23px;
        text-align: center;
    }

    .corner-item {
        margin-bottom: 30px;
    }

    @media (max-width: 834px) {
        div.corner-item {
            width: calc((100% - 20px)/ 2);
        }
    }

    @media (max-width: 834px) {
        .title {
            font-size: 22px;
            line-height: 28px !important;
            margin-bottom: 10px;
        }

        .description {
            font-size: 14px;
            line-height: 18px;
        }

        div.corner-item {
            width: 100%;
            height: 300px;
        }
    }
</style>

